module.exports = __webpack_public_path__ + "img/SETTING.b731b7eb.svg";